import { Link, Palette, Popover, Portal, View, useVisibility } from '@fold-dev/core'
import React, { useState } from 'react'
import { ToolbarButton } from './'

export const ColorPanel = ({ onChange, color, colors }) => {
    return (
        <View
            p="1rem"
            style={{ '--f-color-palette-radius': '50px' } as any}>
            <Palette
                width="100%"
                color={color}
                colors={colors}
                onChange={(color) => {
                    onChange(color)
                }}
            />
            {!!color && (
                <Link
                    m="1rem 0 0 0"
                    display="inline-block"
                    size="sm"
                    className="f-underline"
                    onClick={() => {
                        onChange('')
                    }}>
                    Clear color
                </Link>
            )}
        </View>
    )
}

export type ColorButtonProps = {
    color?: string | undefined
    colors: string[]
    onChange?: (color) => void
    portal?: any
    disabled?: boolean
}

export const ColorButton = (props: ColorButtonProps) => {
    const { color, colors, onChange, portal, disabled } = props
    const { visible, show, hide } = useVisibility()

    return (
        <Popover
            portal={portal}
            focusTrap
            width={190}
            content={
                <ColorPanel
                    colors={colors}
                    color={color}
                    onChange={(color) => {
                        onChange(color)
                        hide()
                    }}
                />
            }
            isVisible={visible}
            onDismiss={hide}>
            <ToolbarButton
                disabled={disabled}
                onClick={show}
                style={{
                    '--f-common-toolbar-button-padding': '0px',
                    '--f-common-toolbar-button-gap': '0px',
                    'width': 'var(--f-common-toolbar-button-height)',
                }}>
                <View
                    radius={50}
                    height="80%"
                    width="80%"
                    bg={color}
                />
            </ToolbarButton>
        </Popover>
    )
}
